import { render, staticRenderFns } from "./bankListsDc.vue?vue&type=template&id=19dc0477"
import script from "./bankListsDc.vue?vue&type=script&lang=js"
export * from "./bankListsDc.vue?vue&type=script&lang=js"
import style0 from "./bankListsDc.vue?vue&type=style&index=0&id=19dc0477&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports